// plop_marker:layouts_import
import BuildingBlocksTabs from "./building-blocks-tabs";
import BoardTabs from "./board-tabs";
import TimelineTabs from "./timeline-tabs";
import ColoredTimerVerticalTabs from "./colored-timer-vertical-tabs";
import TimerVerticalTabs from "./timer-vertical-tabs";
import VerticalTabs from "./vertical-tabs";
import RegularTabs from "./regular-tabs";

export default {
  // plop_marker:layouts_add_layout
  BuildingBlocksTabs,
  BoardTabs,
  TimelineTabs,
  ColoredTimerVerticalTabs,
  TimerVerticalTabs,
  VerticalTabs,
  RegularTabs,
};
